import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import ThemeToggle from "@/components/ThemeToggle";

export default function InviteAcceptPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const accept = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/team/invites/accept", { token, name, password });
      localStorage.setItem("lg_token", data.token);
      localStorage.setItem("lg_user", JSON.stringify(data.user));
      localStorage.setItem("lg_workspace", JSON.stringify(data.workspace));
      await refresh();
      toast.success("Welcome to the team");
      navigate("/app");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not accept invite");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-12 bg-foreground text-background">
        <div className="flex items-center gap-2"><div className="w-7 h-7 rounded-sm bg-background text-foreground flex items-center justify-center font-black tracking-tighter">L</div><span className="font-display font-semibold tracking-tightest">LogiGrowth<span className="text-signal-500">.</span>AI</span></div>
        <div>
          <div className="label-eyebrow text-background/70 mb-3">Join your team</div>
          <h2 className="font-display font-light text-4xl tracking-tightest leading-[1.05]">You've been invited to a<br /><span className="font-black">LogiGrowth workspace.</span></h2>
        </div>
        <div className="font-mono text-xs tracking-wider text-background/50">Invitations expire in 7 days</div>
      </div>
      <div className="flex-1 flex flex-col p-6 lg:p-12 bg-background">
        <div className="flex justify-end"><ThemeToggle /></div>
        <div className="flex-1 flex items-center justify-center">
          <form onSubmit={accept} className="w-full max-w-sm space-y-6" data-testid="invite-accept-form">
            <div><div className="label-eyebrow mb-2">Accept invitation</div><h1 className="font-display font-semibold text-3xl tracking-tightest">Create your account</h1></div>
            <div className="space-y-3">
              <div><Label className="text-xs">Your name</Label><Input data-testid="invite-name" required value={name} onChange={(e) => setName(e.target.value)} /></div>
              <div><Label className="text-xs">Password</Label><Input data-testid="invite-password" type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} /></div>
            </div>
            <Button type="submit" disabled={busy} data-testid="invite-submit" className="w-full rounded-sm">{busy ? "Joining..." : "Accept & join workspace"}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
